<template>
<div class="notice">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'notice',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.notice {
}
</style>
